<template class="m-0">
  <div>
    <b-card v-if="item.class" :id="item.class.id + 'asd'" class="schedule-card"
      :style="teachers[item.class.x_teacher_id[0]]">
      <div style="font-size: 0.9em; font-weight: bold">
        {{ item.class.x_name }}
      </div>
      {{ item.class.x_teacher_id[1] }} ({{
        item.class.x_enrollments_ids.length
      }}/{{ item.class.x_capacity }}) <br>
      <span v-if="item.class.x_comment" style="font-size:0.9em">{{ item.class.x_comment }}</span>
    </b-card>
    <b-popover :target="item.class.id + 'asd'" triggers="hover" placement="top">
      <template #title>{{
        item.class.x_product_template_id[1]
      }}</template>
      {{ item.class.x_name }} <br />
      <span v-if="item.class.x_comment">{{ item.class.x_comment }} </span> <br />
      <b-button style="margin-top: 10px" @click="verInscriptosPop(item)">Inscriptos</b-button>
      <br />
      <b-link :href="'/classes/' + item.class.id">
        <b-button style="margin-top: 10px">Ver Clase</b-button>
      </b-link>
      <br />
      <b-button style="margin-top: 10px" @click="editarClase(item.class)">Editar Clase</b-button>
      <br />
    </b-popover>
    <b-modal :id="'modal-ver-inscriptos' + item.class.id" size="xl" title="Ver Inscriptos">
      <view-class-enrollments :verInscriptosList="verInscriptosList"></view-class-enrollments>
    </b-modal>

  </div>
</template>

<script>
import viewClassEnrollments from '../pop-ups/viewClassEnrollments.vue'

import { EnrollmentsService } from '@/services/enrollments.service'
export default {
  name: 'view-class-item-schedule',
  components: { viewClassEnrollments },
  props: ['item', 'teachers'],
  data () {
    return {
      verInscriptosList: [],
      editClassItem: {}
    }
  },
  async created () {
    // this.verInscriptosList = await EnrollmentsService.read(this.enrollments_ids, [])
  },
  methods: {
    async verInscriptosPop (item) {
      this.verInscriptosList = await EnrollmentsService.read(item.class.x_enrollments_ids, [])
      this.$bvModal.show('modal-ver-inscriptos' + item.class.id)
    },
    verClase (id) {
      // console.log(id)
      // this.$router.push()
      // window.open(routeData.href, '_blank')
    },
    async editarClase (item) {
      this.editClassItem = item
      this.$session.set('editClassItem', item)
      this.$bvModal.show('edit-clase')
    }
  }
}
</script>

<style lang='scss' scoped></style>
